import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Uni30Quota } from 'src/app/modules/shared/models/policy.model';
import { FormUtils } from 'src/app/utils/FormUtils';
import {
  PREV_QUOTE_FILTER_KEY,
  SHARES_COUNTERVALUE_LABEL,
} from '../../pages/policy-detail/policy-detail.constants';
import { IFormKey } from 'src/app/modules/shared/models/forms';
import { Moment } from 'moment';

@Component({
  selector: 'app-policy-quote',
  templateUrl: './policy-quote.component.html',
  styleUrl: './policy-quote.component.scss',
})
export class PolicyQuoteComponent implements OnInit {
  @Input() shareList: Uni30Quota[] = [];
  @Input() counterValue: number;
  @Input() filteredQuotes: Uni30Quota[] = [];
  @Output() retrieveQuote = new EventEmitter<any>();

  public form: FormGroup;
  public counterValueLabel: string = SHARES_COUNTERVALUE_LABEL;
  public formKeys: IFormKey[];
  public filteredList: Uni30Quota[];

  private formLayout: any;

  ngOnInit(): void {
    this.formKeys = PREV_QUOTE_FILTER_KEY;
    this.formLayout = {
      dateFilter: '',
    };

    const button = this.formKeys.find((key) => key.id === 'filterButton');
    if (button) button.action = this.filterSharesByDate.bind(this);

    this.filteredList = this.shareList;
    this.form = FormUtils.initFormGroupFromTemplate(this.formLayout);
  }

  public filterSharesByDate() {
    const dateValue: Moment | null = this.form.get('dateFilter')?.value ?? null;

    if (!dateValue) {
      console.warn('PolicyQuoteComponent - No date chosen. All results are shown.');
      this.filteredList = this.shareList;
      return;
    }

    console.info('PolicyQuoteComponent - Filtering for chosen date:', dateValue.toDate());
    this.filteredList = []
    this.retrieveQuote.emit(dateValue);

  }


  get quotesToShow(): Uni30Quota[] {
    return this.filteredQuotes && this.filteredQuotes.length > 0 ? this.filteredQuotes : this.filteredList;
  }

  get isQuoteTableHidden(): boolean {
    return !!this.shareList.length;
  }
}
